import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Google Analytics (gtag.js) page_view on every React Router route
 * change. The initial pageview is fired by the `gtag('config', ...)` call
 * in `public/index.html`; this component only handles SPA navigations.
 *
 * No-op when gtag isn't loaded (ad blockers, dev environments without
 * the script tag, etc).
 */
const GA_ID = "G-74E9H47EDZ";
const AW_ID = "AW-772432870";

export default function GoogleAnalytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    // Skip the very first render — gtag('config', ...) in index.html
    // already counted that one. Subsequent route changes need a manual
    // page_view event so the path updates in GA + Google Ads.
    if (window.__gaInitialPageview === false) {
      const payload = {
        page_path: pathname + search,
        page_location: window.location.href,
        page_title: document.title,
      };
      // GA4 (measurement)
      window.gtag("event", "page_view", { ...payload, send_to: GA_ID });
      // Google Ads (remarketing / conversion attribution across SPA routes)
      window.gtag("event", "page_view", { ...payload, send_to: AW_ID });
    } else {
      window.__gaInitialPageview = false;
    }
  }, [pathname, search]);

  return null;
}
